import { styled } from "@glitz/react";
import { white, black, green, spacing, fontSize, fontWeight } from "../../theme";

const SelectWrapper = styled.div({
  display: "flex",
  flexDirection: "column",
  gap: spacing.xxs,
  width: "100%",
});

const SelectField = styled.select({
  width: "100%",
  padding: { xy: spacing.xs },
  fontSize: fontSize.s,
  border: { xy: { style: "solid", color: black, width: "1px" } },
  borderRadius: "4px",
  backgroundColor: white,
  transitionDuration: "0.2s",
  transitionProperty: "border-color",
  transitionTimingFunction: "ease",

  ":focus": {
    outline: { style: "none" },
    border: { xy: { style: "solid", color: green, width: "1px" } },
  },
});

const Label = styled.label({
  fontSize: fontSize.s,
  color: black,
  fontWeight: fontWeight.bold,
});

const Option = styled.option({
  fontSize: fontSize.s,
});

type Option = {
  value: string;
  label: string;
};

type SelectProps = {
  label: string;
  options: Option[];
  value: string;
  onChange: (value: string) => void;
};

const Select: React.FC<SelectProps> = ({ label, value, onChange, options }) => {
  return (
    <SelectWrapper>
      <Label>{label}</Label>
      <SelectField value={value} onChange={(e) => onChange(e.target.value)}>
        <option value="">Välj {label}</option>
        {options.map((option) => (
          <option key={option.value} value={option.value}>
            {option.label}
          </option>
        ))}
      </SelectField>
    </SelectWrapper>
  );
};

export default Select;
